import { BaseTextFieldProps, OutlinedInputProps } from "@mui/material";
import { useField } from "formik";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers";
import React, { useEffect, useMemo } from "react";
import { isEmpty } from "lodash";
import moment from "moment";

export interface IEFormTextField {
  id: string;
  label: string;
  placeholder?: string;
  InputProps?: Partial<OutlinedInputProps>;
  defaultValue?: string | number;
  inputProps?: BaseTextFieldProps;
  disabled?: boolean;
}

const EFormDatePicker = (props: IEFormTextField) => {
  const { id, label, defaultValue, inputProps, disabled } = props;
  const [_, meta, helper] = useField(id);

  const onChange = (date: any) => {
    helper.setValue(date);
  };

  const _value = useMemo(() => {
    if (meta.value) {
      if (typeof meta.value === "string") {
        return moment(meta.value);
      }
      return meta.value;
    } else if (defaultValue) {
      if (typeof defaultValue === "string") {
        return moment(defaultValue);
      }
      return defaultValue;
    }
    return undefined;
  }, [meta.value, defaultValue]);

  return (
    <DatePicker
      label={label}
      value={_value}
      onChange={onChange}
      disabled={disabled}
      sx={{ width: "100%" }}
      // render={(params: any) => (
      //   <TextField
      //     {...params}
      //     {...inputProps}
      //     sx={{ width: "100%" }}
      //     error={meta.touched && !isEmpty(meta.error)}
      //     helperText={meta.touched && meta.error}
      //   />
      // )}
    />
  );
};

export default EFormDatePicker;
